import { AfterViewInit, Component } from '@angular/core'
import { combineLatest, map, Observable } from 'rxjs'
import { Job, PipelineType } from '../../shared/model/jobs'
import { UploadProgress, UploadService } from '../../shared/services/upload.service'
import { Store } from '@ngrx/store'
import { selectJobs } from '../../state/job/job.selectors'
import { jobActions } from '../../state/job/job.actions'

@Component({
    selector: 'app-job-status-dialog',
    templateUrl: './job-status-dialog.component.html',
    styleUrls: ['./job-status-dialog.component.scss'],
})
export class JobStatusDialogComponent implements AfterViewInit {
    private readonly jobs$: Observable<Job[]>
    readonly jobsData: Observable<JobsData>

    constructor(readonly upload: UploadService, private store: Store) {
        this.jobs$ = this.store.select(selectJobs)
        this.jobsData = combineLatest({
            segmentationJobs: this.filterJobs([PipelineType.Segmentation]),
            registrationJobs: this.filterJobs([
                PipelineType.Registration,
                PipelineType.mIHC,
                PipelineType.cycIF,
            ]),
            nucleusExpansionJobs: this.filterJobs([PipelineType.NucleusExpansion]),
            cubingJobs: this.filterJobs([PipelineType.Cubing]),
            recurrentNeighborhoodsJobs: this.filterJobs([PipelineType.RecurrentNeighborhoods]),
            neighborhoodEnrichmentJobs: this.filterJobs([PipelineType.NeighborhoodEnrichment]),
            mapIntensityJobs: this.filterJobs([PipelineType.MapIntensity]),
            autoCellDetectionJobs: this.filterJobs([PipelineType.AutoCellDetection]),
            clusteringJobs: this.filterJobs([
                PipelineType.tsneClustering,
                PipelineType.umapClustering,
            ]),
            uploadDatasetName: this.upload.datasetName$,
            uploadProgress: this.upload.currentUploadProgress$,
        })
    }

    ngAfterViewInit(): void {
        this.store.dispatch(jobActions.reloadJobs())
    }

    filterJobs(jobTypes: PipelineType[]): Observable<Job[]> {
        return this.jobs$.pipe(map(jobs => jobs.filter(job => jobTypes.includes(job.type))))
    }
}

interface JobsData {
    segmentationJobs: Job[]
    registrationJobs: Job[]
    nucleusExpansionJobs: Job[]
    cubingJobs: Job[]
    recurrentNeighborhoodsJobs: Job[]
    neighborhoodEnrichmentJobs: Job[]
    mapIntensityJobs: Job[]
    autoCellDetectionJobs: Job[]
    clusteringJobs: Job[]
    uploadDatasetName: string | undefined
    uploadProgress: UploadProgress | undefined
}
